import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { charlestonConfig } from "./data";

export default function CharlestonPage() {
  return <CityPageTemplate config={charlestonConfig} />;
}